import { useTranslation } from 'react-i18next';
import { CloseOutlined, ExclamationCircleOutlined, SaveOutlined } from '@ant-design/icons';
import { Avatar, Button, Col, Collapse, CollapseProps, Drawer, Form, message, Modal, Row, Select, Space, Table, TreeSelect, Typography } from 'antd';
import { RuleObject } from 'antd/es/form';
import { StoreValue } from 'antd/es/form/interface';
import _, { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import FormItemDropdown from "../../../../components/form-dropdown/FormItemDropdown";
import FormInput from "../../../../components/form-input/FormInput";
import { IS_QTCS, IS_QTDH } from '../../../../constants';
import { createBasicAdminAccount, getAllEnterpriseUniversity, getDetailBasicAdminAccount, getDetailManagementParticipatePlatform, getPlatformRegistrationRequired, getRoleDefaultAccount, updateBasicAdminAccount } from '../../../../service/management-participate-platform';
import { globalStore } from '../../../../stores/stores';
import { regexEmail, regexPassword } from '../../../../utils/regex';
import { getManagedChildrenUniversities, getManageUniversities, getpositions } from '../../../user-info/account/services';
import "./index.scss";

type Props = {
  open: boolean,
  handleClose: () => void,
  fetchData: () => void,
  detailData: any,
  mode: string
}
interface University {
  id: number;
  uuid: string;
  name: string;
  canManage: boolean;
  logo?: string | null;
  children?: University[];
  isDaiHoc: boolean;
  universityId: number;
}

const FormCreateUser = (props: Props) => {
  const { t } = useTranslation();
  const { open, handleClose, fetchData, detailData, mode } = props
  const [form] = Form.useForm()
  const [status, setStatus] = useState<number>(1)
  const [listParticipant, setListParticipant] = useState<any>([]);
  const [listRole, setListRole] = useState<any>([]);
  const [listPosition, setListPosition] = useState<any>([]);
  const [listEnterprise, setListEnterprise] = useState<any>([]);
  const [requestChoose, setRequestChoose] = useState<any>(0)
  const [enterPriseId, setEnterPriseId] = useState<any>(0)
  const [dataDetail, setDataDetail] = useState<any>({})
  const [dataSource, setDataSource] = useState<University[]>([]);
  const [selectedTrainingFacility, setSelectedTrainingFacility] = useState<University | null>(null);
  const [managedChildrenUniversities, setManagedChildrenUniversities] = useState<University[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const { personalInfo } = globalStore();

  const validations = {
    contactPeople: {
      required: true,
      message: t("Vui lòng nhập thông tin người liên hệ", "Vui lòng nhập thông tin người liên hệ")
    },
    contactRolePeople: {
      required: true,
      message: t("Vui lòng chọn chức vụ người liên hệ", "Vui lòng chọn chức vụ người liên hệ")
    },
    phone: {
      required: true,
      message: t("Vui lòng nhập số điện thoại", "Vui lòng nhập số điện thoại")
    },
    emailContact: [
      {
        required: true,
        message: t("Vui lòng nhập địa chỉ email", "Vui lòng nhập địa chỉ email")
      },
      ({ getFieldValue }: { getFieldValue: (name: string) => StoreValue }) => ({
        validator: (_: unknown, value: any) => {
          if (!isEmpty(value) && !value.match(new RegExp(regexEmail))) {
            return Promise.reject(
              new Error(t("Định dạng email không đúng, vui lòng nhâp lại", "Định dạng email không đúng, vui lòng nhâp lại"))
            );
          }
          return Promise.resolve();
        },
      }),
    ],
    trainingFacility: {
      required: true,
      message: t("Vui lòng chọn cơ sở đào tạo", "Vui lòng chọn cơ sở đào tạo")
    },
    emailLogin: [
      {
        required: true,
        message: t("Vui lòng nhập địa chỉ email", "Vui lòng nhập địa chỉ email")
      },
      ({ getFieldValue }: { getFieldValue: (name: string) => StoreValue }) => ({
        validator: (_: unknown, value: any) => {
          if (!isEmpty(value) && !value.match(new RegExp(regexEmail))) {
            return Promise.reject(
              new Error(t("Định dạng email không đúng, vui lòng nhâp lại", "Định dạng email không đúng, vui lòng nhâp lại"))
            );
          }
          return Promise.resolve();
        },
      }),
    ],
    roleLogin: {
      required: true,
      message: t("Vui lòng chọn vai trò", "Vui lòng chọn vai trò")
    },
    passwordLogin: [
      {
        required: mode === "edit" ? false : true,
        message: t("Vui lòng nhập mật khẩu", "Vui lòng nhập mật khẩu"),
      },
      {
        min: 8,
        max: 25,
        message: t("Độ dài mật khẩu từ 8-25 ký tự.", "Độ dài mật khẩu từ 8-25 ký tự."),
      },
      {
        pattern: regexPassword,
        message:
          t("Mật khẩu phải bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt, và có độ dài từ 8-25 ký tự.", "Mật khẩu phải bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt, và có độ dài từ 8-25 ký tự."),
      },
      ({ getFieldValue }: { getFieldValue: (name: string) => StoreValue }) => ({
        validator(_: RuleObject, value: StoreValue) {
          if (value && getFieldValue("oldPassword") === value) {
            return Promise.reject(
              new Error(t("Mật khẩu mới phải khác mật khẩu hiện tại.", "Mật khẩu mới phải khác mật khẩu hiện tại."))
            );
          }
          return Promise.resolve();
        },
      }),
    ],
    passwordLoginConfirm: [
      {
        required: mode === "edit" ? false : true,
        message: t("Vui lòng xác nhập mật khẩu mới", "Vui lòng xác nhập mật khẩu mới"),
      },
      ({ getFieldValue }: { getFieldValue: (name: string) => StoreValue }) => ({
        validator(_: RuleObject, value: StoreValue) {
          if (!isEmpty(value)) {
            if (getFieldValue("passwordLogin") === value) {
              return Promise.resolve();
            }
            return Promise.reject(
              new Error(t("Mật khẩu không khớp.", "Mật khẩu không khớp."))
            );
          }
          return Promise.resolve();
        },
      }),
    ],
  }
  const generateTreeData = (nodes: University[]): any[] => {
    return nodes?.map((node) => {
      const { id, name, logo, children } = node;

      return {
        title: (
          <Space>
            <Avatar shape="square" size="small" src={logo} />
            {name}
          </Space>
        ),
        value: id,
        dataRef: node,
        children: children && children.length > 0 ? generateTreeData(children) : undefined,
      };
    });
  };

  const findNodeById = (nodes: University[], id: number): University | undefined => {
    for (const node of nodes) {
      if (node.id === id) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        const found = findNodeById(node.children, id);
        if (found) {
          return found;
        }
      }
    }
    return undefined;
  };

  const blockOne = () => (
    <>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item name="managementAgency" label={t("Yêu cầu đăng ký tham gia nền tảng", "Yêu cầu đăng ký tham gia nền tảng")} >
            <Select
              options={listParticipant}
              onChange={(value: any, option: any) => {
                form.setFieldsValue({
                  contactPeople: option?.userContact,
                  contactRolePeople: option?.userContactPositionId,
                  phone: option?.userContactPhone,
                  emailContact: option?.userContactEmail,
                })
                setRequestChoose(value)
              }}

              allowClear={true}
              placeholder={t("Chọn đơn vị yêu cầu tham gia nền tảng", "Chọn đơn vị yêu cầu tham gia nền tảng")}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="contactPeople" label={t("Người liên hệ", "Người liên hệ")} rules={[validations.contactPeople]}>
            <FormInput
              placeholder={t("Nhập người liên hệ", "Nhập người liên hệ")}
              disabled={requestChoose !== 0}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="contactRolePeople" label={t("Chức vụ", "Chức vụ")} rules={[validations.contactRolePeople]}>
            <FormItemDropdown
              options={listPosition}
              allowClear={true}
              placeholder={t("Chọn chức vụ", "Chọn chức vụ")}
              disabled={requestChoose !== 0}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24} className="">
        <Col span={12}>
          <Form.Item name="phone" label={t("Số điện thoại", "Số điện thoại")} rules={[validations.phone]}>
            <FormInput
              placeholder={t("Nhập số điện thoại người liên hệ", "Nhập số điện thoại người liên hệ")}
              disabled={requestChoose !== 0}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="emailContact" label="Email" rules={validations.emailContact}>
            <FormInput
              placeholder={t("Nhập email người liên hệ", "Nhập email người liên hệ")}
              disabled={requestChoose !== 0}
            />
          </Form.Item>
        </Col>
      </Row>
      <Col span={24}>
        <Form.Item name="trainingFacility" label={t("Cơ sở đào tạo", "Cơ sở đào tạo")} rules={[validations.trainingFacility]}>
          <TreeSelect
            treeData={generateTreeData(dataSource)}
            placeholder={t("Chọn cơ sở đào tạo", "Chọn cơ sở đào tạo")}
            treeDefaultExpandAll
            showSearch
            allowClear={personalInfo?.role !== IS_QTDH && personalInfo?.role !== IS_QTCS}
            onChange={(value) => {
              const selectedNode = findNodeById(dataSource, value);
              setSelectedTrainingFacility(selectedNode || null);
              form.setFieldsValue({ trainingFacility: value });
            }}
            filterTreeNode={(input, treeNode) =>
              (treeNode.dataRef?.name || '').toLowerCase().includes(input.toLowerCase())
            }
            notFoundContent={
              <span style={{ textAlign: "center" }}>
                <p>
                  <img
                    className="image-empty-data"
                    src="/images/empty-img-gray.png"
                    alt="empty-img"
                  ></img>
                </p>
                <p className="nodata-text">{t("Không tìm thấy", "Không tìm thấy")}</p>
              </span>
            } />


        </Form.Item>
      </Col>
    </>
  )

  const blockTwo = () => (
    <>
      <Row gutter={24}>

        <Col span={12}>
          <Form.Item name="emailLogin" label={t("Email đăng nhập", "Email đăng nhập")} rules={validations.emailLogin}>
            <FormInput
              placeholder={t("Nhập email đăng nhập", "Nhập email đăng nhập")}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="roleLogin" label={t("Vai trò", "Vai trò")} rules={[validations.roleLogin]}>
            <FormItemDropdown
              options={listRole}
              allowClear={true}
              placeholder={t("Chọn vai trò", "Chọn vai trò")}
              modeDropdown="multiple"
            />
          </Form.Item>
        </Col>
      </Row>
      {
        mode === "edit" ? null :
          <Row gutter={24} className="">
            <Col span={12}>
              <Form.Item name="passwordLogin" label={t("Mật khẩu", "Mật khẩu")} rules={validations.passwordLogin}>
                <FormInput
                  placeholder={t("Nhập mật khẩu cho tài khoản", "Nhập mật khẩu cho tài khoản")}
                  style={{ height: '32px' }}
                  passwordInput={true}
                  autoComplete="new-password"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="passwordLoginConfirm" label={t("Xác nhận mật khẩu", "Xác nhận mật khẩu")} rules={validations.passwordLoginConfirm}>
                <FormInput
                  placeholder={t("Xác nhận mật khẩu cho tài khoản", "Xác nhận mật khẩu cho tài khoản")}
                  passwordInput={true}
                  style={{ height: '32px' }}
                  autoComplete="new-password"
                />
              </Form.Item>
            </Col>
          </Row>
      }
      <Row gutter={24} className="">
        <Col span={24}>
          <Form.Item name="status" label={t("Trạng thái", "Trạng thái")}>
            <Space.Compact block>
              <Button className={status === 1 ? 'active' : ''} onClick={() => setStatus(1)}>{t("Mở khóa", "Mở khóa")}</Button>
              <Button className={status === 2 ? 'active' : ''} onClick={() => setStatus(2)}>{t("Khóa", "Khóa")}</Button>
            </Space.Compact>
          </Form.Item>
        </Col>
      </Row>
    </>
  )

  //lay danh sach yeu cau tham gia nen tang
  const getListRequestJoin = async () => {
    try {
      const res = await getPlatformRegistrationRequired()
      const { data } = res.data
      const listOption = data?.map((item: any) => {
        return {
          ...item,
          value: item?.id,
          label: item?.name
        }
      })
      setListParticipant(listOption)
    } catch (error) {

    }

  }

  const getEnterprise = async () => {
    const data = {
      page: 1,
      size: 10000,
      keyword: "",
    };

    await getAllEnterpriseUniversity(data)
      .then((res) => {
        const listOption = res?.data?.data?.content?.map((item: any) => ({
          id: item?.universityId,
          name: item?.name
        }))
        setListEnterprise(listOption)
      })
  }

  //lay danh sach chuc vu
  const getPostion = async () => {
    await getpositions()
      .then((res) => {
        const { data } = res.data
        setListPosition(data)
      })
  }

  //lay danh sach vai trò default
  const getRoleDefault = async () => {
    const data = {
      keyword: "",
      pageNumber: 1,
      pageSize: 999999,
      checkRole: "1"
    }
    await getRoleDefaultAccount(data)
      .then((res) => {
        if (!isEmpty(res.data.data)) {
          if (mode === "add" && open) {
            form.setFieldValue("roleLogin", res.data?.data?.filter((item: any) => item.default?.split(',').includes("1"))
              .map((item: any) => item.id))
          }
        }
        setListRole(res.data.data)

      })
  }

  const createAccount = async (values: any) => {
    const data = {
      universityRegisterId: values.managementAgency,
      userContact: values.contactPeople,
      userContactPhone: values.phone,
      userContactEmail: values.emailContact,
      userContactPosition: [values.contactRolePeople],
      userEmail: values.emailLogin,
      userPassword: values.passwordLogin ?? null,
      userRePassword: values.passwordLoginConfirm ?? null,
      userStatus: status === 1 ? true : false,
      roles: _.isArray(values.roleLogin) ? values.roleLogin : [values.roleLogin],
      isQTDH: dataDetail?.role === "is_qtdh",
      universityIds: (totalRecords > selectedRowKeys?.length && selectedRowKeys?.length !== 0) ? selectedRowKeys : [],
      universityId: selectedTrainingFacility?.id,
    }

    if (mode === "edit") {
      await updateBasicAdminAccount(detailData?.id, data).then((res) => {
        if (res.status === 200) {
          message.success(t("Sửa tài khoản thành công", "Sửa tài khoản thành công"))
        }
      })

    } else {
      await createBasicAdminAccount(data).then((res) => {
        if (res.status === 200) {
          message.success(t("Tạo tài khoản thành công", "Tạo tài khoản thành công"))
        }
      })
    }
    handleClose()
    fetchData()
    form.resetFields()
    setStatus(1)
    setDataDetail({})
    setRequestChoose(0)
    setManagedChildrenUniversities([])
    setSelectedTrainingFacility(null)

  }

  const getListDataDetail = async () => {
    await getDetailBasicAdminAccount(detailData?.id).then((res) => {
      if (res.status === 200) {
        const detail = res.data?.data
        setDataDetail(detail)
        setSelectedTrainingFacility(detail?.managedEnterprises?.[0]?.canManage ? detail?.managedEnterprises?.[0] : null)
        form.setFieldsValue({
          managementAgency: detail?.universityRegisterId ? detail?.universityRegisterId : undefined,
          contactPeople: detail?.userContact,
          contactRolePeople: detail?.userContactPositionId,
          phone: detail?.userContactPhone,
          emailContact: detail?.userContactEmail,
          trainingFacility: detail?.unitId || detail?.unitName || detail?.managedEnterprises?.[0]?.id,
          emailLogin: detail?.username,
          roleLogin: detail?.roles?.map((item: any) => { return item.id }),
        })
        if (detail?.universityRegisterId) {
          setRequestChoose(detail?.universityRegisterId)
        }
        setEnterPriseId(detail?.unitId)
        setStatus(detail?.isActive ? 1 : 2)
      }
    })
  }

  useEffect(() => {
    if (open) {
      getListRequestJoin()
      getPostion()
      getRoleDefault()
      getEnterprise()
    }
  }, [open])

  useEffect(() => {
    if ((requestChoose !== 0 && requestChoose !== undefined) || (dataDetail?.universityRegisterId)) {
    } else {
      form.resetFields()
    }
  }, [requestChoose])

  useEffect(() => {
    if (mode === "edit" && open) {
      setTimeout(() => {
        getListDataDetail();
      }, 0);
    } else {
      form.resetFields()
      // setManagedChildrenUniversities([])
      // setDataDetail({})
      // setSelectedTrainingFacility(null)

    }
  }, [open, mode])

  useEffect(() => {
    if (mode === "edit") {
      getListRequestJoin();
    }
  }, [dataDetail])

  useEffect(() => {
    if (open && personalInfo?.role === IS_QTDH || personalInfo?.role === IS_QTCS) {
      form.setFieldsValue({ trainingFacility: personalInfo?.managedEnterprises?.[0]?.id });
      setSelectedTrainingFacility(personalInfo?.managedEnterprises?.[0])
    }
  }, [personalInfo, open, mode])

  const clearFilter = () => {
    form.resetFields()
    setStatus(1)
    setDataDetail({})
    handleClose()
    setSelectedTrainingFacility(null)
    setRequestChoose(0)
  }

  const processChildren = (data: University[]): University[] => {
    return data.map((item) => {
      const newItem = { ...item };
      if (newItem.children && newItem.children.length === 0) {
        delete newItem.children;
      } else if (newItem.children) {
        newItem.children = processChildren(newItem.children);
      }
      return newItem;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      const res = await getManageUniversities({});
      const formattedData = processChildren(
        res.data.data.map((item: any) => ({
          ...item,
          key: item.id,
          children: item.children?.map((child: any) => ({
            ...child,
            key: child.id,
          })),
        }))
      );
      setDataSource(formattedData);

    };
    if (open) fetchData()
  }, [open])

  useEffect(() => {
    const uuid = selectedTrainingFacility?.uuid;

    const fetchData = async () => {
      setLoading(true);
      try {
        if (uuid) {
          const res = await getManagedChildrenUniversities(uuid);
          setManagedChildrenUniversities(res?.data.data);
          setTotalRecords(res?.data.data?.length);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    if (open && uuid) {
      setTimeout(() => {
        fetchData();
      }, 0);
    }
    else {
      setManagedChildrenUniversities([]);
    }
  }, [open, selectedTrainingFacility, dataDetail]);

  useEffect(() => {
    if (dataDetail?.managedEnterprises?.[0] && mode === "edit" && dataDetail?.managedEnterprises?.[0]?.uuid === selectedTrainingFacility?.uuid) {
      const enterprise = dataDetail.managedEnterprises[0];

      if (enterprise.canManage) {
        setSelectedRowKeys(managedChildrenUniversities.map((uni) => uni.id));
      } else {
        const childIds = enterprise.children?.map((child: any) => child.id) || [];
        const matchingIds = managedChildrenUniversities
          .filter((uni) => childIds.includes(uni.id))
          .map((uni) => uni.id);

        setSelectedRowKeys(matchingIds);
      }
    }
  }, [dataDetail, managedChildrenUniversities]);

  useEffect(() => {
    if (open) setSelectedRowKeys([])
  }, [selectedTrainingFacility])

  const columns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      width: 60,
      render: (text: string, record: University, index: number) => (
        <div className="flex align-center gap-8">
          {index + 1}
        </div>
      ),
    },
    {
      title: t('Mã trường', 'Mã trường'),
      dataIndex: 'code',
      key: 'code',
      width: 140
    },
    {
      title: t('Tên trường', 'Tên trường'),
      dataIndex: 'name',
      key: 'name',
      render: (text: string, record: University) => (
        <div className="flex align-center gap-8">
          <Avatar shape="square" size="small" src={record?.logo} />
          {text}
        </div>
      ),
    },

  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(selectedRows);
    },
  };
  const handleTableChange = (pagination: any) => {

  };

  const items: CollapseProps['items'] = [
    {
      key: '1',
      label: <Typography.Title level={5}><strong>{t("Thông tin cơ sở đào tạo", "Thông tin cơ sở đào tạo")}</strong></Typography.Title>,
      children: blockOne(),
    },
    ...managedChildrenUniversities?.length > 0 ?
      [
        {
          key: '2',
          label: <Typography.Title level={5}><strong>{t("Trường quản trị", "Trường quản trị")}</strong></Typography.Title>,
          children: <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={managedChildrenUniversities}
            loading={loading}
            pagination={false}
            title={() => (
              <thead >
                <tr>
                  <div className='thead-title-university'>
                    {selectedTrainingFacility?.name}
                  </div>
                  <div className='scroll-selected'> {t('Đã chọn', 'Đã chọn')} {selectedRowKeys?.length} {t('trường', 'trường')}</div>
                </tr>
              </thead>
            )}
            rowKey="id"
            onChange={handleTableChange}
            scroll={{ x: 500, y: 500 }}
          />,
        },
      ] : [],
    {
      key: '3',
      label: <Typography.Title level={5}><strong>{t("Thông tin tài khoản", "Thông tin tài khoản")}</strong></Typography.Title>,
      children: blockTwo(),
    },
  ];
  return (
    <>
      <Form.Provider onFormFinish={(name, { values, forms }) => {
        if (name === "add-chapter") {
          Modal.confirm({
            title: t("Xác nhận tạo tài khoản", "Xác nhận tạo tài khoản"),
            content: t("Đảm bảo tất cả các thông tin liên quan đã được kiểm tra trước khi xác nhận.", "Đảm bảo tất cả các thông tin liên quan đã được kiểm tra trước khi xác nhận."),
            onOk: () => {
              createAccount(values)
            },
            okText: t("Xác nhận", "Xác nhận"),
            cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
            centered: true,
            icon: <ExclamationCircleOutlined style={{ color: "#1677FF" }} />,
            footer: (_, { OkBtn, CancelBtn }) => (
              <>
                <CancelBtn />
                <OkBtn />
              </>
            ),
          });
        }
      }}>
        <Drawer
          title={`${mode === "edit" ? t("Sửa", "Sửa") : t("Tạo", "Tạo")} ${t("tài khoản Quản trị cơ sở (QTCS)", "tài khoản Quản trị cơ sở (QTCS)")}`}
          open={open}
          onClose={clearFilter}
          width={736}
          className="create-form-facility-management"

          extra={
            <Space>
              <Button onClick={() => {
                form.resetFields()
                clearFilter()
                setManagedChildrenUniversities([])
                setSelectedTrainingFacility(null)
              }} className="btn btn-outlined">
                <CloseOutlined />
                <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
              </Button>
              <Button className="btn btn-primary"
                onClick={() => form.submit()
                }>
                <SaveOutlined />
                <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
              </Button>
            </Space>
          }
        >
          <Form
            layout={"vertical"}
            form={form}
            name="add-chapter"
            autoComplete="off"
          >
            <Collapse defaultActiveKey={['1', '2', '3']} ghost items={items} />


          </Form>
        </Drawer>
      </Form.Provider>
    </>
  );
};

export default FormCreateUser;
